import { render } from "./WhatsInAName.vue?vue&type=template&id=66265d02"
import script from "./WhatsInAName.vue?vue&type=script&lang=ts"
export * from "./WhatsInAName.vue?vue&type=script&lang=ts"
script.render = render

export default script